import {Component, Input, OnInit} from "@angular/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DbResponse} from "../../../../../shared/interceptors/db-response";
import {DbServerErrors} from "../../../../../shared/interceptors/db-server-errors";
import {HostingService} from "../../hosting.service";
import {Website} from "../../../website";
import {DbValidators} from "../../../../../shared/validators/DbValidators";
import {Notification} from "../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../shared/components/notifier/notification-type";
import {NotifierComponent} from "../../../../../shared/components/notifier/notifier.component";
import {DbActiveModal} from "../../../../../modules/modal/modal-ref";
import {filter, first} from "rxjs/operators";

@Component({
    selector: 'db-add-custom-domain-dialog',
    templateUrl: './add-custom-domain-dialog.component.html',
    styleUrls: ['./add-custom-domain-dialog.component.scss'],
    standalone: false
})
export class AddCustomDomainDialogComponent implements OnInit {

  @Input() website: Website;
  @Input() fromHostingManageAll: any = false;
  @Input() ipv4Address: string;
  public changes: any;
  public loading: boolean = false;
  public responseReceived: boolean;
  public zoneNotCreated: boolean;
  public zoneLimitExceeded: boolean;
  public formSubmitted: boolean;
  public serverErrors: DbServerErrors;
  public domainForm: FormGroup;
  public nameservers: any;
  public subdomainCase: boolean;
  modalClosedResult = {result: false};

  constructor(
    private _hostingService: HostingService,
    public activeModal: DbActiveModal,
  ) {
  }

  ngOnInit() {
    this.formSubmitted = false;
    this.domainForm = new FormGroup({
      'domain_name': new FormControl("", [DbValidators.trim, Validators.required, Validators.pattern('^(([a-zA-Z]{1})|([a-zA-Z]{2})|([a-zA-Z]{1}[0-9]{1})|([0-9]{1}[a-zA-Z]{1})|([a-zA-Z0-9][-_.a-zA-Z0-9]{0,61}[a-zA-Z0-9]))\.((xn--[a-zA-Z0-9-]{1,59})|([a-zA-Z]{2,13})|([a-zA-Z0-9-]{2,30}\.[a-zA-Z]{2,3}))$')]),
      'createZone': new FormControl(false)
    });
  }

  keyDownFunction(event) {
    if (event.keyCode === 13) {
      event.preventDefault();
      if (!this.loading) {
        this.confirm();
      }
    }
  }

  public confirm(): void {
    this.formSubmitted = true;
    let result = null;
    if (this.domainForm.valid) {
      this.loading = true;
      this.serverErrors = null;
      if (this.domainForm.value.domain_name) {
        this._hostingService.checkDomain(this.domainForm.value.domain_name)
          .pipe(
            filter((_response: DbResponse): boolean => !!_response),
            first()
          ).subscribe((response: DbResponse): void => {
          if (this.domainForm.valid && response.success) {
            if (!this.fromHostingManageAll) {
              const websiteID = this.website?.multisiteType === 'subfolder' ? this.website?.children[0] : this.website?.id;
              this._hostingService.createDomain(websiteID, this.domainForm.value)
                .pipe(
                  filter((_response: DbResponse): boolean => !!_response),
                  first()
                ).subscribe((response: DbResponse): void => {
                this.loading = false;

                if (response.success) {
                  this.responseReceived = true;
                  result = {success: true};
                  this.modalClosedResult = result;
                  if (response.data) {
                    if (response.data.nameservers) {
                      this.nameservers = JSON.parse(response.data.nameservers);
                    } else if (response.data.zone_error && response.data.zone_error.code === 'error.zone_limit') {
                      this.zoneLimitExceeded = true;
                    } else if (response.data.zone_error && (response.data.zone_error.code === 'error.something_went_wrong.create_zone' || response.data.zone_error.code === 'error.duplicate_zone')) {
                      this.zoneNotCreated = true;
                    } else if (!response.data.zone_error && !response.data.nameservers) {
                      this.subdomainCase = true;
                    }
                  }
                } else {
                  this.serverErrors = response.serverErrors;
                  NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));

                }
              });

            } else {
              this._hostingService.createZone(this.domainForm.value)
                .pipe(
                  filter((_response: DbResponse): boolean => !!_response),
                  first()
                ).subscribe((response: DbResponse): void => {
                this.loading = false;

                if (response.success) {
                  result = {success: true};
                  this.activeModal.close(result);
                } else {
                  this.serverErrors = response.serverErrors;
                }

              });
            }
          } else {
            this.loading = false;
            this.serverErrors = response.serverErrors ? response.serverErrors : response.response ? response.response['error'] : "";
          }
        });
      }
    }
  }

}
